/* eslint-disable custom-eslint-rules/force-logicalOperandsMustBeBoolean */
import { ReactElement } from "react";
import { Flex } from "../../Flex/Flex.js";
import { CloseLinear } from "../../Iconsax/CloseLinear.js";
import { TagV2 } from "../../TagV2/TagV2.js";
import { Text } from "../../Text/Text.js";
import { TextSize } from "../../Text/Text.types.js";
import { SelectV2Option, SelectV2Value } from "../SelectV2.types.js";

type SelectedTagsProps<Value extends SelectV2Value> = {
    values: Value[];
    options: SelectV2Option<Value>[];
    onRemove: (value: Value) => void;
    maxDisplayCount?: number;
};

export const SelectedTags = <Value extends SelectV2Value>({
    values,
    options,
    onRemove,
    maxDisplayCount = 2,
}: SelectedTagsProps<Value>): ReactElement | null => {
    if (!values || values.length === 0) {
        return null;
    }

    const displayValues = values.slice(0, maxDisplayCount);
    const hasMore = values.length > maxDisplayCount;

    return (
        <Flex align="center" gap="4">
            {displayValues.map((value) => {
                const option = options.find((o) => o.value === value);
                return option ? (
                    <TagV2
                        key={`${option.label}${option.value}`}
                        iconRight={CloseLinear}
                        displayIconOnHover
                        color={option.color || "primary"}
                        onIconClick={(e) => {
                            e.stopPropagation();
                            onRemove(value);
                        }}
                    >
                        {option.label}
                    </TagV2>
                ) : null;
            })}

            {hasMore && <Text size={TextSize["X-SMALL"]}>{`+${values.length - maxDisplayCount}`}</Text>}
        </Flex>
    );
};
